'use client';

import NextImage from 'next/image';
import { FC } from 'react';

import { getMedia } from '@/lib/utils';
import { ImageProps } from '@/types/common';

const Image: FC<ImageProps> = ({ src, width, height, alt, quality, onLoad, ...rest }) => {
	const strapiImage = getMedia(src);

	return (
		<NextImage
			{...rest}
			width={width ?? strapiImage?.width}
			height={height ?? strapiImage?.height}
			alt={strapiImage?.alternativeText ?? alt}
			src={typeof src === 'string' ? src : (strapiImage?.url ?? '')}
			quality={quality ?? 75}
			onLoad={onLoad}
		/>
	);
};

export default Image;
